import { PhoneNumber } from './PhoneNumber.js';
import { getIn } from 'formik';
import { jsx } from '@emotion/react/jsx-runtime';

function fieldToPhoneNumber(_ref) {
  let {
    disabled,
    field: {
      onBlur: fieldOnBlur,
      onChange: onFormikChange,
      ...field
    },
    form: {
      isSubmitting,
      touched,
      errors
    },
    onChange,
    onBlur,
    ...props
  } = _ref;
  const handleOnChange = value => {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    onFormikChange({
      target: {
        name: field.name,
        value
      }
    });
  };
  const handleOnBlur = value => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
  };
  return {
    isInvalid: getIn(touched, field.name) && !!getIn(errors, field.name),
    disabled: disabled || isSubmitting,
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    ...field,
    ...props
  };
}
function FormikPhoneNumber(_ref2) {
  let {
    ...props
  } = _ref2;
  return jsx(PhoneNumber, {
    ...fieldToPhoneNumber(props)
  });
}

export { FormikPhoneNumber, fieldToPhoneNumber };
//# sourceMappingURL=FormikPhoneNumber.js.map
